import { Expand } from "lucide-react";
import ModalImage from "react-modal-image";

export default function Project({
  title,
  linkableID = "",
  descriptionHTML,
  images,
  cons,
  pros,
}) {
  return (
    <section className="mx-auto container" id={linkableID}>
      <h3 className="text-xl font-medium tracking-tight text-center text-gray-900 sm:text-[2.25rem] mb-10 md:mb-20">
        <span className="relative z-10">
          {title}
          <svg
            className="absolute -bottom-2 right-0 sm:-bottom-3 -z-10 max-w-52 sm:max-w-fit sm:w-fit"
            viewBox="0 0 432.5 28.14"
          >
            <path
              d="M12.74,22.37c62.64-3.26,49.59-7.18,187.94-9.79s151.4,1.3,227.1,2"
              transform="translate(-4 -2.96)"
              fill="none"
              strokeLinecap="round"
              strokeMiterlimit="8px"
              strokeWidth="5px"
              strokeDasharray="0,0"
              stroke="#FE6D00"
            ></path>
          </svg>
        </span>
      </h3>
      <p className="whitespace-break-spaces max-w-5xl mx-auto mb-20" dangerouslySetInnerHTML={{ __html: descriptionHTML }} />
      <div className="flex flex-row gap-4 max-w-5xl mx-auto mb-20 space-x-10 flex-wrap">
        <div className="lg:max-w-1/2">
          <h4 className="text-xl font-semibold mb-2   text-green-600">
            Voordelen
          </h4>
          <ul className="list-disc list-inside space-y-2 ">
            {pros?.map((pro, index) => (
              <li key={`pro-${index}`}>{pro}</li>
            ))}
          </ul>
        </div>
        <div className="lg:max-w-1/2">
          <ul className="list-disc list-inside space-y-2">
            <h4 className="text-xl font-semibold mb-2  text-red-600">
              Nadelen/Risico's
            </h4>
            {cons?.map((con, index) => (
              <li key={`con-${index}`}>{con}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-7xl mx-auto rounded-lg">
        {images?.map(({ src, alt }, index) => (
          <figure className="relative w-full h-full">
            <ModalImage
              key={index}
              alt={alt}
              small={src}
              large={src}
              className="rounded-lg shadow-lg object-cover w-full hover:opacity-70 mb-2  md:aspect-video md:h-80 border border-gray-200"
            />
            <span className="absolute top-2 right-2 p-2 bg-white rounded-lg text-gray-900 text-xs font-semibold pointer-events-none"> <Expand size={24} color="#fa7900" strokeWidth={2} absoluteStrokeWidth />  </span>
            <figcaption className="text-left"> {alt} </figcaption>
          </figure>
        ))}
      </div>
      <div></div>
    </section>
  );
}
